import { EMPTY, Observable } from 'rxjs';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {
  Injectable,
  InjectionToken
} from '@angular/core';

import { LoaderService } from 'src/app/components/loader/loader.service';
import { MESSAGES } from 'src/app/constants/messages.constants';
import { PUBLIC_ROUTE } from 'src/app/constants/routes.constants';
import { Router } from '@angular/router';
import { ToastService } from './../../components/toast-notification/toast.service';
import { Token } from '../token/index'
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');


@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private $loader: LoaderService,
    private $popup: ToastService,
    private $token: Token,
    private $router: Router
  ) { }
  // intercept all http requests
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // check internet connectivity
    if (!navigator.onLine) {
      this.$popup.error(MESSAGES.OFFLINE);
      this.$loader.hide();
      return EMPTY;
    }
    let headers: any;
    // this.$loader.markAsLoading();
    const isApiUrl = req.url.charAt(0) === '~';
    const authorization = this.$token.hasValue ? this.$token.header : `basic ${btoa('aog:aog@123')}`;
    headers = {
      authorization: req.headers.get('Authorization') || authorization,
      api_key: environment.API_KEY,
      platform: environment.PLATFORM,
      timezone: `${-new Date().getTimezoneOffset() * 60 * 1000}`
    }
    if (req.url.indexOf('blob.core.windows') !== -1) {

      headers = {};
    }
    return next.handle(req.clone({
      setHeaders: headers,
      url: isApiUrl ? `${environment.apiBaseUrl}${req.url.substr(1)}` : req.url // add base url
    })).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          if (event.status !== 201) {
            this.$loader.hide();
          }
        }
        // return throwError(error);
      }, event => {
        if (event instanceof HttpErrorResponse) {
          console.log(event);
          this.$loader.hide();
          if (event.status === 401) {
            if (req.url.indexOf('blob.core.windows') === -1) {
              this.$loader.hide();
            }
            // alert()
            this.$token.reset();
            this.$router.navigateByUrl(PUBLIC_ROUTE.url);
            this.$popup.error(MESSAGES.ERROR.$401);
            window.location.reload();
          } else if (event.status === 504) {
            this.$popup.error(MESSAGES.ERROR.$504);
          } else if (event.status === 0) {
            this.$popup.error(MESSAGES.ERROR.$0);
          } else {
            this.$popup.error(event.error.message);
          }
        }
      })
    );
  }
}
